// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"15f03758","221":"75892769","344":"3fdb9df0","453":"62f6f46e","571":"aa499a96","678":"92733842","726":"99219d84","999":"f3a4d318"}[chunkId] + ".chunk.js";
};